import React from "react";
import styled from "styled-components";
import { position, PositionProps } from "styled-system";
import { MenuItem as MenuItemProps } from "../../types/Menu";
import { Box } from "../Box";
import { MenuItemLink } from "../MenuItemLink";
import { DropRightHeader } from "./_/DropRightHeader";

const Content = styled(Box)<PositionProps>`
  ${position};
  display: none;
  box-shadow: inset 5px 0px 10px 0px rgba(0, 0, 0, 0.5);
`;

const HoverArea = styled(Box)`
  &:hover > ${Content} {
    display: block;
  }
  position: relative;
`;

export const DropRightMenuItem: React.FC<MenuItemProps> = ({
  title,
  url,
  subMenu,
  highlightColor,
}) => (
  <HoverArea>
    <DropRightHeader title={title} url={url} highlightColor={highlightColor} />
    <Content
      left="100%"
      top="0"
      position="absolute"
      py={2}
      bg="white"
      borderRadius={5}
      maxWidth={200}
      minWidth={180}
      mt={-2}
    >
      {subMenu!.map(item => (
        <Box key={item.title} py={2} px={3}>
          <MenuItemLink to={item.url} color="primary">
            {item.title}
          </MenuItemLink>
        </Box>
      ))}
    </Content>
  </HoverArea>
);
